import { FC, useEffect, useState, useRef } from "react";
import {
  Flex,
  Box,
  Text,
  Image,
  Modal,
  ModalContent,
  ModalCloseButton,
  ModalOverlay,
  useDisclosure,
  Icon,
} from "@chakra-ui/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import { getPortfolio } from "../../services/profile";
import { SERVICES_IMAGE_URL } from "../../core/constants";

interface PortfolioProps {
  id: string;
}

export const Portfolio: FC<PortfolioProps> = ({ id }) => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  const [portfolio, setPortfolio] = useState<any[]>([]);
  const [selectedImage, setSelectedImage] = useState<any>();

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollContainerRef.current) {
      const scrollAmount =
        direction === "left"
          ? -scrollContainerRef.current.clientWidth
          : scrollContainerRef.current.clientWidth;
      scrollContainerRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const fetchPortfolio = async () => {
      setPortfolio(await getPortfolio(id));
    };

    fetchPortfolio();
  }, [id]);

  const calculatedWidth = `calc(50vw - 25px)`;

  const closeModal = () => {
    onClose();
    setSelectedImage(undefined);
  };

  const handleSelect = (image: any) => {
    setSelectedImage(image);
    onOpen();
  };

  return (
    <Box mt="20px">
      <Flex alignItems="center">
        <Icon
          boxSize={10}
          cursor="pointer"
          onClick={() => scroll("left")}
          marginRight={"20px"}
          display={{ base: "none", md: "flex" }}
        >
          <FaChevronLeft />
        </Icon>

        <Flex
          ref={scrollContainerRef}
          p={{ base: 0, md: 1 }}
          wrap={{ base: "wrap", md: "nowrap" }}
          gap={"10px"}
          overflowX={{ base: undefined, md: "scroll" }}
          whiteSpace={{ base: undefined, md: "wrap" }}
          css={{
            "&::-webkit-scrollbar": { display: "none" },
            msOverflowStyle: "none",
            scrollbarWidth: "none",
          }}
        >
          {portfolio &&
            Object.entries(portfolio).length !== 0 &&
            portfolio?.map((item) => (
              <Box
                key={item._id}
                boxShadow="0px 2px 5px rgba(0, 0, 0, 0.1)"
                p="4px 4px 12px 4px"
                bg="#FFFFFF"
                w={{ base: calculatedWidth, md: "164px" }}
                borderRadius={"12px"}
                flexShrink={0}
              >
                {item.file_type === "video" ? (
                  <Box
                    as="video"
                    src={`${SERVICES_IMAGE_URL}/${item.file_name}`}
                    objectFit={"cover"}
                    w={"-webkit-fill-available"}
                    h="156px"
                    borderRadius={"8px"}
                    cursor={"pointer"}
                    onClick={() => handleSelect(item)}
                    muted
                    playsInline
                  />
                ) : (
                  <Image
                    src={`${SERVICES_IMAGE_URL}/${item.file_name}`}
                    objectFit={"cover"}
                    w={"-webkit-fill-available"}
                    h="156px"
                    borderRadius={"8px"}
                    cursor={"pointer"}
                    onClick={() => handleSelect(item)}
                  />
                )}

                <Text
                  mt="10px"
                  color={"#19202D"}
                  textAlign={"center"}
                  fontWeight={600}
                  lineHeight={"21px"}
                  px="35px"
                  noOfLines={2}
                >
                  {item.service_name}
                </Text>
              </Box>
            ))}
        </Flex>

        <Icon
          boxSize={10}
          cursor="pointer"
          onClick={() => scroll("right")}
          marginLeft={"20px"}
          display={{ base: "none", md: "flex" }}
        >
          <FaChevronRight />
        </Icon>
      </Flex>

      <Modal isCentered isOpen={isOpen} onClose={closeModal} size={"lg"}>
        <ModalOverlay bg="#999" backdropFilter="blur(10px) hue-rotate(90deg)" />

        <ModalContent
          borderRadius={"12px"}
          flexShrink={0}
          boxShadow="0px 2px 5px rgba(0, 0, 0, 0.1)"
          p="4px 4px 12px 4px"
          bg="#FFFFFF"
        >
          {selectedImage?.file_type === "video" ? (
            <Box
              as="video"
              src={`${SERVICES_IMAGE_URL}/${selectedImage?.file_name}`}
              objectFit={"contain"}
              w={"-webkit-fill-available"}
              borderRadius={"8px"}
              controls
              autoPlay
            />
          ) : (
            <Image
              src={`${SERVICES_IMAGE_URL}/${selectedImage?.file_name}`}
              objectFit={"cover"}
              w={"-webkit-fill-available"}
              // h="156px"
              borderRadius={"8px"}
              cursor={"pointer"}
            />
          )}

          <Text
            mt="10px"
            color={"#19202D"}
            textAlign={"center"}
            fontWeight={600}
            lineHeight={"21px"}
            px="35px"
            noOfLines={2}
          >
            {selectedImage?.service_name}
          </Text>

          <ModalCloseButton bg={"white"} borderRadius={"full"} />
        </ModalContent>
      </Modal>
    </Box>
  );
};
